// Currency is a property of the Studio/record, independent of the UI language.
// Finalized financial snapshots always take precedence over today's settings.
export function currencyCode(source, fallback = "EUR") {
  const value = typeof source === "string" ? source : source?.financial_snapshot?.currency || source?.currency || source?.settings?.currency;
  const code = String(value || fallback || "EUR").trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : "EUR";
}
export const currencyLabel = (source, fallback = "EUR") => {
  const code = currencyCode(source, fallback);
  return code === "EUR" ? "€" : code;
};
export const moneyLabel = (value, source, fallback = "EUR") =>
  `${currencyLabel(source, fallback)} ${Number(value || 0).toFixed(2)}`;
